import { render, staticRenderFns } from "./HistoricoScfv.vue?vue&type=template&id=6217568e"
import script from "./HistoricoScfv.vue?vue&type=script&lang=js"
export * from "./HistoricoScfv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports